import { Component } from '@angular/core';

@Component({
    selector: 'app-error-page-redirector',
    template: '',
    standalone: false
})
export class ErrorPageRedirectorComponent {
  constructor() {}
}
